import React from "react"
import PropTypes from "prop-types"
import * as styles from "./SmallCard-tw-styles"
import Link from "../Link/Link"
import { getRecipeMedia, getProductImages } from "../../../helpers/tastehub.helpers"
import { getProductUrl, getRecipeUrl } from "../../../constants/locale.constants"
import { gaEventClasses } from "../../../constants/gtm.constants"

function SmallCard(props) {
    const { recipe, product } = props
    const item = recipe || product
    const isRecipe = !!recipe
    const style = isRecipe ? styles.RECIPE : styles.PRODUCT

    if (!item) {
        return null
    }

    const url = isRecipe ? getRecipeUrl(item) : getProductUrl(item)
    const media = isRecipe ? getRecipeMedia(item)?.detailPage : getProductImages(item)?.main
    const title = item?.title || item?.name || ""

    return (
        <Link url={url} className={style.wrapper} gaEventClass={gaEventClasses.image_click} gaEventLabel={title}>
            <div className={style.imageWrapper}>
                <img src={media?.url} width={media?.width} height={media?.height} alt={title} className={style.image} />
            </div>
            <h3 className={style.title}>{title}</h3>
        </Link>
    )
}

export default SmallCard

SmallCard.propTypes = {
    recipe: PropTypes.object,
    product: PropTypes.object,
}
